import axios from "axios";

// const jigyaasu = "https://api.jigyaasu.ai";
const jigyaasu = "https://api.dhootschool.jigyaasu.ai";

const apiClient = axios.create({
  baseURL: jigyaasu,
  withCredentials: true,
  timeout: 30000,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global response handling — auth expiry etc.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Requests that pass `skipAuthRedirect: true` in their config (e.g. the
    // login call itself) opt out of the auto-redirect — a 401 there means
    // "wrong password", not "session expired", so we let the caller handle
    // the error inline instead of navigating away.
    const skipAuthRedirect = error?.config?.skipAuthRedirect;

    if (error?.response?.status === 401 && !skipAuthRedirect) {
      localStorage.removeItem("access_token");
      // Prefer dispatching a logout action if you have access to the store here.
      // Otherwise a hard redirect works fine:
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;